import request from "@/utils/request";

// 获取区域地址列表            (通过)
export function AddressRegionList() {
  return request({
    url: '/apis/sra/common/users/signup/qryAddressRegion',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
  })
}

// 获取省市地区列表       (通过)
export function AddressByCodeRegionList(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qryAddressByCodeRegion',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 所属集团公司列表       (通过)
export function companyList(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qryBelongSupplierList',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 查询校验供应商名称、统一信用代码、用户名等是否已存在
export function checkSuppilerInfo(data) {
  return request({
    url: '/apis/sra/smc/users/signup/checkSuppilerInfo',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 校验手机号
export function checkMobileVerificationCode (data) {
  return request({
    url: '/apis/sra/smc/users/signup/checkMobileVerificationCode',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}
// 校验email
export function checkEmailVerificationCode(data) {
  return request({
    url: '/apis/sra/smc/users/signup/checkEmailVerificationCode',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}
// 发送邮箱验证码
export function checkSendEmailCode(data) {
  return request({
    url: '/apis/sra/smc/users/signup/checkSendEmailCode',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册申请账号信息新增          （通过）
export function createSupplierAccount(data) {
  return request({
    url: '/apis/sra/smc/users/signup/createSupplierAccount',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    timeout: 60 * 1000,
    data
  })
}

// 查询推荐单位列表及推荐单位下的供应商质量类型列表
export function qrySuptypeQualList(data) {
  return request({
    url: '/apis/sp/manage/qrySuptypeQualList',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册或变更查询供应商基本信息。       （通过）
export function qrySupRegistBaseInfoMDL(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qrySupRegistBaseInfoMDL',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册或变更查询供应商基本信息。       （通过）
export function qrySupRegistBaseInfo(data) {
  return request({
    url: '/apis/sra/smc/qrySupRegistBaseInfo',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 币种字典列表查询      (通过)
export function currency(data) {
  return request({
    url: '/apis/sra/common/users/signup/qryDictByCode',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 修改保存提交供应商注册信息      （通过）
export function saveSupplierRegistInfo(data) {
  return request({
    url: '/apis/sra/smc/saveSupplierRegistInfo',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 查询设备物资类别树列表    （通过）
export function qryMatcateryTreeList(data) {
  return request({
    url: '/apis/sra/mtc/qryMatcateryTreeList',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册中查询供应商历史合作业绩信息。
export function qrySupRegistHisPerformMDL(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qrySupRegistHisPerformMDL',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册中查询供应商历史合作业绩信息。
export function qrySupRegistHisPerform(data) {
  return request({
    url: '/apis/sra/smc/qrySupRegistHisPerform',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册、变更时查询供应商财务信息。
export function qrySupRegistFinanceInfoMDL(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qrySupRegistFinanceInfoMDL',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册、变更时查询供应商财务信息。
export function qrySupRegistFinanceInfo(data) {
  return request({
    url: '/apis/sra/smc/qrySupRegistFinanceInfo',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册\变更时查询产品信息
export function qrySupRegistProductInfoMDL(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qrySupRegistProductInfoMDL',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册\变更时查询产品信息
export function qrySupRegistProductInfo(data) {
  return request({
    url: '/apis/sra/smc/qrySupRegistProductInfo',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册中查询联系信息。
export function qrySupRegistContactInfoMDL(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qrySupRegistContactInfoMDL',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册中查询联系信息。
export function qrySupRegistContactInfo(data) {
  return request({
    url: '/apis/sra/smc/qrySupRegistContactInfo',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册或变更时查询申请账户信息。
export function qrySupRegistAccountInfoMDL(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qrySupRegistAccountInfoMDL',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册或变更时查询申请账户信息。
export function qrySupRegistAccountInfo(data) {
  return request({
    url: '/apis/sra/smc/qrySupRegistAccountInfo',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 用于供应商推荐单位录入后校验是否存在
export function checkRecommendOrg(data) {
  return request({
    url: '/apis/sra/smc/users/signup/checkRecommendOrg',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册中查询资质文件信息
export function qrySupRegistQualificationFileListMDL(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qrySupRegistQualificationFileListMDL',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商注册中查询资质文件信息
export function qrySupRegistQualificationFileList(data) {
  return request({
    url: '/apis/sra/smc/qrySupRegistQualificationFileList',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 供应商类型字典列表查询      (通过)
export function supType(data) {
  return request({
    url: '/apis/sra/common/users/signup/qryDictByCode',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 获取短信验证码
export function sendVerificationCode(data) {
  return request({
    // url: '/apis/sra/users/signup/subconauthaccountinfo/sendVerificationCode',
    url: '/apis/sra/smc/users/signup/checkSendMobileCode',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 校验短信验证吗
export function checkContactByMobile(data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/checkContactByMobile',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 天眼查查询供应商
export function qryTycSearch(data) {
  return request({
    url: '/apis/sra/smc/users/signup/fuzzyQueryCompany',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 白名单查询
export function qrySupWhiteListBySupName(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qrySupWhiteListBySupName',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 查询供应商在天眼查中的信息
export function qrySupTycInfo(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qrySupTycInfo',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}

// 查询供应商国别
export function qryAllDiffCounAddress(data) {
  return request({
    url: "/apis/sra/common/users/signup/qryAllDiffCounAddress",
    method: "post",
    data
  });
}

//查询供应商基本信息。
export function qrySupBaseInfo(data) {
  return request({
    url: "/apis/scpma/smc/qrySupBaseInfo",
    method: "post",
    data
  });
}

//查询供应商历史合作业绩信息
export function qrySupHisPerform(data) {
  return request({
    url: "/apis/scpma/smc/qrySupHisPerform",
    method: "post",
    data
  });
}

//供应商查询资质文件信息
export function qrySupplierQualificationFile(data) {
  return request({
    url: "/apis/scpma/smc/qrySupplierQualificationFile",
    method: "post",
    data
  });
}

//供应商联系信息
export function qrySupplierLinkInfo(data) {
  return request({
    url: "/apis/scpma/smc/qrySupplierLinkInfo",
    method: "post",
    data
  });
}

//供应商产品信息
export function qrySupplierProductInfo(data) {
  return request({
    url: "/apis/scpma/smc/qrySupplierProductInfo",
    method: "post",
    data
  });
}

//供应商财务信息
export function qrySupFinanceInfo(data) {
  return request({
    url: "/apis/scpma/smc/qrySupFinanceInfo",
    method: "post",
    data
  });
}

//供应商完善信息验证手机号
export function checkSupplierInfoByMobile(data) {
  return request({
    url: "/apis/sra/smc/users/signup/checkSupplierInfoByMobile",
    method: "post",
    data
  });
}

//供应商审核信息详情
export function qrySupAuditDetail(data) {
  return request({
    url: "/apis/sra/smc/users/signup/qrySupAuditDetail ",
    method: "post",
    data
  });
}

//撤回申请
export function dealSupApprReturn(data) {
  return request({
    url: "/apis/sra/smc/dealSupApprReturn",
    method: "post",
    data
  });
}

//审批记录查询
export function qryApprovalRecord(data) {
  return request({
    url: "/apis/sra/mtc/qryApprovalRecord",
    method: "post",
    data
  });
}

// 字典接口
export function qryDictByCode(data) {
  return request({
    url: '/apis/sra/common/users/signup/qryDictByCode',
    method: 'post',
    headers: {
      "Content-Type": "application/json"
    },
    data
  })
}


//单位性质字典
export function queryCompanyPropertyTree(data) {
  return request({
    url: "/apis/sra/smc/users/signup/queryCompanyPropertyTree",
    method: "post",
    data
  });
}


//推荐单位-搜索
export function queryMemberGroup(data) {
  return request({
    url: "/apis/sra/smc/users/signup/querySupComMaintainByName",
    method: "post",
    data
  });
}

//推荐单位-组织机构树
export function queryRecommendedUnitTree(data) {
  return request({
    url: "/apis/sra/smc/users/signup/queryRecommendedUnitTree",
    method: "post",
    data
  });
}
// 身份证认证
export function qryIdCardByHwOcr(data) {
  return request({
    url: "/apis/sra/hw/users/signup/qryIdCardByHwOcr",
    method: "post",
    data
  });
}
// 2025-12-06 获取图形验证码
export function getImageVerifyCode(obj) {
  return request({
    url: "/apis/sra/smc/users/signup/getImageVerifyCode",
    method: "get",
    data: obj
  });
}
